import { useAuth } from '@/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type ClinicRole = 'owner' | 'admin' | 'staff';

export function useMyClinicRole() {
  const { profile } = useAuth();

  const { data: role = null, isLoading } = useQuery({
    queryKey: ['my-clinic-role', profile?.clinic_id, profile?.email],
    queryFn: async () => {
      if (!profile?.clinic_id || !profile?.email) return null;
      const { data } = await supabase
        .from('clinic_members')
        .select('role')
        .eq('clinic_id', profile.clinic_id)
        .eq('email', profile.email)
        .maybeSingle();
      return (data?.role as ClinicRole) ?? null;
    },
    enabled: !!profile?.clinic_id && !!profile?.email,
  });

  return { role, isLoading };
}
